module.exports = __webpack_public_path__ + "static/img/AnLe_orange.06b28cb5.png";